var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightFromBracketSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5C5.55312 15 6 14.5531 6 14C6 13.4469 5.55312 13 5 13H3C2.44781 13 2 12.5522 2 12V4C2 3.44781 2.44781 3 3 3H5C5.55312 3 6 2.55219 6 2C6 1.44781 5.55312 1 5 1H3C1.34312 1 0 2.34312 0 4V12C0 13.6562 1.34312 15 3 15ZM15.775 7.45312L11.2719 3.20312C11.0539 2.99756 10.7344 2.94141 10.4594 3.05956C10.1843 3.17822 10.0059 3.44925 10.0059 3.74863L10.0031 5.99862L6.00307 5.99859C5.45026 5.99859 5.00244 6.44641 5.00244 6.99859V8.99859C5.00244 9.55078 5.45057 9.99859 6.00307 9.99859L10.0031 9.99862L10.0059 12.2205C10.0059 12.5198 10.1843 12.7908 10.4594 12.9096C10.7345 13.0277 11.0541 12.9716 11.2719 12.766L15.775 8.516C16.075 8.2625 16.075 7.7375 15.775 7.45312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFromBracketSolid);
export default __webpack_public_path__ + "static/media/right-from-bracket-solid.b6f404823206acd3fc5700681c8f8dff.svg";
export { ForwardRef as ReactComponent };